export default __webpack_public_path__ + "static/media/bg_with_smoke_light.f7c33cfc.png";